import { SalesStore } from 'store/sales/types.ts'

export const initialSalesState: SalesStore = {
  loading: false,
  error: '',
  events: [],
  parameters: [],
  partners: [],
  users: []
}
